/* eslint-disable react/no-danger */
import { useEffect } from 'react';

import Head from 'next/head';
import { Col, Container, Row } from 'reactstrap';

import Layout from '../../../components/layout/layout';
import useI18n from '../../../hooks/use-i18n';
import { languages, contentLanguageMap } from '../../../language.config';
import getTranslationKeys, { PAGEID } from '../../../utils/i18nRosseta';

import '../../../styles/commercial-law.scss';

const sections = [
  'section_1',
  'section_2',
  'section_11',
  'section_12',
  'section_3',
  'section_4',
  'section_5',
  'section_6',
  'section_7',
  'section_8',
  'section_9',
  'section_10'
];

const CommercialLaw = () => {
  const i18n = useI18n();
  const commercialLaw = i18n.t('commercial_law');
  const codes = i18n.activeLocale.split('-');
  const country = codes.length === 2 ? codes[0] : 'sg';
  const pageMetaData = i18n.t('metadata').commercial_law;

  useEffect(() => {
    if (country !== 'jp') {
      window.location = '/';
    }
  }, []);

  return (
    <Layout
      page="commercial_law"
      description={pageMetaData.description}
      title={pageMetaData.title}
      keywords={pageMetaData.keywords}
      analyticData={{ name: 'Commercial Law', properties: { } }}
      pageUrl="specified-commercial-transactions"
      pageEnabledMarkets={[]}
    >
      <Head />
      {country === 'jp' && (
        <section className="commercial-page-wrapper">
          <Container>
            <Row>
              <Col xl={{ size: 12 }} className="commercial-content">
                <h1>{commercialLaw.page_title}</h1>
                <ul>
                  {sections.map((section) => <li dangerouslySetInnerHTML={{ __html: commercialLaw[section] }} />)}
                </ul>
              </Col>
            </Row>
          </Container>
          <Container className="partner-clinic-section">
            <Row>
              <Col xl={{ size: 12 }}>
                <h2>{commercialLaw.partner_clinic.section_title}</h2>
                <table>
                  <thead>
                    <th
                      data-key="commercial_law::partner_clinic::table_heading1"
                      data-lokalise=""
                    >
                      {commercialLaw.partner_clinic.table_heading1}
                    </th>
                    <th
                      data-key="commercial_law::partner_clinic::table_heading2"
                      data-lokalise=""
                    >
                      {commercialLaw.partner_clinic.table_heading2}
                    </th>
                    <th
                      data-key="commercial_law::partner_clinic::table_heading3"
                      data-lokalise=""
                    >
                      {commercialLaw.partner_clinic.table_heading3}
                    </th>
                    <th
                      data-key="commercial_law::partner_clinic::table_heading4"
                      data-lokalise=""
                    >
                      {commercialLaw.partner_clinic.table_heading4}
                    </th>
                    <th
                      data-key="commercial_law::partner_clinic::table_heading5"
                      data-lokalise=""
                    >
                      {commercialLaw.partner_clinic.table_heading5}
                    </th>
                  </thead>
                  <tbody>
                    {Object.values(commercialLaw.partner_clinic.table_content).map((data, index) => (
                      <tr>
                        {Object.values(data).map((value, key) => (
                          // eslint-disable-next-line jsx-a11y/control-has-associated-label
                          <td
                            data-title={commercialLaw.partner_clinic[`table_heading${key + 1}`]}
                            data-key={
                              `commercial_law::partner_clinic::table_content::table_row${index + 1}::data${key + 1}`
                            }
                            data-lokalize=""
                            dangerouslySetInnerHTML={{ __html: value }}
                          />
                        ))}
                      </tr>))}
                  </tbody>
                </table>
              </Col>
            </Row>
          </Container>
        </section>
      )}
    </Layout>
  );
};

export async function getStaticProps({ params }) {
  const lngDict = {};
  const pageId = PAGEID.SPECIFIED_COMMERCIAL_TRANSACTIONS;
  const keys = getTranslationKeys(pageId);
  const { default: lngDictAll = {} } = await import(
    `../../../locales/${contentLanguageMap[params.lng]}.json`
  );
  keys.forEach((data) => {
    lngDict[data] = lngDictAll[data];
  });
  return {
    props: { lng: params.lng, lngDict, pageId }
  };
}

export async function getStaticPaths() {
  return {
    paths: languages.map((l) => ({ params: { lng: l } })),
    fallback: false
  };
}

export default CommercialLaw;
